<template>
    <div>
        <!-- 顶部导航 -->
        <NavTop ref="navtop"></NavTop>
        <!-- 消息 -->
        <div class="chat">
            <div class="chat_main row">
                <div class="chat_main_l column">
                    <div class="chat_main_l_top">
                        <!-- <el-input placeholder="搜索30天内的联系人" v-model="lianxiren" size="mini" clearable
                            @keydown.enter.native="handleSearchEnter">
                            <i slot="prefix" class="el-input__icon el-icon-search" @click="clickSearchIcon"></i>
                        </el-input> -->
                        <!-- <el-autocomplete v-model="lianxiren" size="mini" :fetch-suggestions="querySearchAsync" clearable
                            placeholder="搜索30天内的联系人" @select="handleSelect" style="width: 100%;">
                            <i slot="prefix" class="el-input__icon el-icon-search" @click="clickSearchIcon"></i>
                        </el-autocomplete> -->
                        <span class="lianxirenliebiao">联系人列表</span>
                    </div>
                    <div class="chat_main_l_m column">
                        <div class="chat_main_l_m_tabs row">
                            <!-- <div :class="tabs == 1 ? 'chat_main_l_m_tabs_m2' : 'chat_main_l_m_tabs_m'"
                                @click="clickChatTabs(1)">
                                全部</div>
                            <div :class="tabs == 2 ? 'chat_main_l_m_tabs_m2' : 'chat_main_l_m_tabs_m'"
                                @click="clickChatTabs(2)">
                                新招呼</div>
                            <div :class="tabs == 3 ? 'chat_main_l_m_tabs_m2' : 'chat_main_l_m_tabs_m'"
                                @click="clickChatTabs(3)">
                                仅沟通</div>
                            <div :class="tabs == 4 ? 'chat_main_l_m_tabs_m2' : 'chat_main_l_m_tabs_m'"
                                @click="clickChatTabs(4)">
                                有交换</div>
                            <div :class="tabs == 5 ? 'chat_main_l_m_tabs_m2' : 'chat_main_l_m_tabs_m'"
                                @click="clickChatTabs(5)">
                                有面试</div> -->
                        </div>
                        <div class="chat_main_l_m_list column">
                            <div v-for="(item, index) in chatList" :key="index"
                                :class="xuanzeId == item.id ? 'chat_main_l_m_list_m2 row' : 'chat_main_l_m_list_m row'"
                                @click="dianjigoutong(item)">
                                <div class="chat_main_l_m_list_m_l">
                                    <span class="chat_main_l_m_list_m_l_num" v-if="item.unreadCnt">
                                        {{ item.unreadCnt }}
                                    </span>
                                    <img :src="item.opAvatar" class="chat_main_l_m_list_m_l_img">
                                </div>
                                <div class="chat_main_l_m_list_m_r column">
                                    <div class="chat_main_l_m_list_m_r_top row">
                                        <div class="chat_main_l_m_list_m_r_top_l row">
                                            <span class="chat_main_l_m_list_m_r_top_l_name" :title="item.opName">
                                                {{ item.opName }}
                                            </span>
                                            <span class="chat_main_l_m_list_m_r_top_l_gongsi">
                                                {{ item.opCmp }} | {{ item.opJob }}
                                            </span>
                                        </div>
                                        <div class="chat_main_l_m_list_m_r_top_r" v-if="item.lastMsgTime">
                                            {{ item.lastMsgTime | formatDateMD }}
                                        </div>
                                    </div>
                                    <div class="chat_main_l_m_list_m_r_bottom row">
                                        <div class="chat_main_l_m_list_m_r_bottom_text">
                                            <span v-if="item.lastMsg">消息：{{ item.lastMsg }}</span>
                                        </div>
                                        <div class="chat_main_l_m_list_m_r_bottom_del row">
                                            <i class="el-icon-upload2" title="取消置顶" v-if="item.fixTop == 1"
                                                @click="clickliebiaoquxiaozhiding(item)"></i>
                                            <i class="el-icon-upload2" title="置顶" v-if="item.fixTop == 0"
                                                @click="clickliebiaozhiding(item)"></i>
                                            <i class="el-icon-delete" title="删除" style="margin-left: 5px;"
                                                @click="clickliebiaoshanchu(item)"></i>
                                        </div>
                                    </div>
                                </div>
                                <img v-if="item.fixTop == 1" class="zhidingjiantou" src="@/assets/images/icon-stick.png">
                            </div>
                            <div class="chat_main_l_m_list_bottom">
                                没有更多了
                            </div>
                        </div>
                    </div>
                </div>
                <div class="chat_main_r column" v-if="!huihuazhuangtai">
                    <div class="chat_main_r_imgtext column">
                        <img class="chat_main_r_img" src="@/assets/images/icon-welcome.png">
                        <div class="chat_main_r_text">与您进行过沟通的都会在左侧列表中显示</div>
                    </div>
                </div>
                <div class="chat_main_r column" v-else>
                    <div class="chat_main_r_top column">
                        <div class="chat_main_r_top_t row">
                            <div class="chat_main_r_top_t_l row">
                                <div class="chat_main_r_top_t_l_name">{{ info.opName }}</div>
                                <div class="chat_main_r_top_t_l_gongsi row">
                                    <span>{{ info.opCmp }}</span>
                                    <span style="color: #e0e0e0;margin: 0 5px;" v-if="info.opCmp && info.opJob"> | </span>
                                    <span>{{ info.opJob }}</span>
                                </div>
                            </div>
                            <div class="chat_main_r_top_t_r row">
                                <div class="chat_main_r_top_t_r_zhiding" v-if="info.fixTop == 0"
                                    @click="clickZhiding(info)">置顶</div>
                                <div class="chat_main_r_top_t_r_zhiding" v-if="info.fixTop == 1"
                                    @click="clickquxiaoZhiding(info)">取消置顶</div>

                            </div>
                        </div>
                        <div class="chat_main_r_top_b row">
                            <div class="chat_main_r_top_b_l row" @click="tiaozhuanzhaopin">
                                <div class="chat_main_r_top_b_l_job">{{ info.jobName }}</div>
                                <div class="chat_main_r_top_b_l_xinzi" v-if="info.salaryType == 0">
                                    {{ info.salaryLowest }}-{{ info.salaryHighest }}K*{{ info.salaryCnt }}
                                </div>
                                <div class="chat_main_r_top_b_l_xinzi" v-if="info.salaryType == 1">
                                    {{ info.salaryLowest }}-{{ info.salaryHighest }}K
                                </div>
                                <div class="chat_main_r_top_b_l_xinzi" v-if="info.salaryType == 2">
                                    面议
                                </div>
                                <div class="chat_main_r_top_b_l_dizhi">{{ info.workCities }}</div>
                            </div>
                        </div>
                    </div>
                    <div ref="chatbox" class="chat_main_r_main" @scroll="handleScroll">
                        <div class="chat_main_r_main_list column">
                            <div class="chat_main_r_main_list_m" v-for="(item, index) in chatMessagesList" :key="index">
                                <!-- 右边 -->
                                <div class="chat_main_r_main_list_mr column" v-if="item.fromId == userId">
                                    <div class="chat_main_r_main_list_m_r row" v-if="item.type == 1">
                                        <div class="chat_main_r_main_list_m_r_text">
                                            {{ item.content }}
                                        </div>
                                    </div>
                                    <div class="chat_main_r_main_list_m_r row" v-if="item.type == 3">
                                        <div class="chat_main_r_main_list_m_r_text">
                                            你已向对方发送简历
                                        </div>
                                    </div>
                                    <div class="chat_main_r_main_list_m_r row" v-if="item.type == 5">
                                        <div class="chat_main_r_main_list_m_r_text">
                                            你已向对方发送电话：{{ item.content }}
                                        </div>
                                    </div>
                                    <div class="chat_main_r_main_list_m_r row" v-if="item.type == 7">
                                        <div class="chat_main_r_main_list_m_r_text">
                                            你已向对方发送微信：{{ item.content }}
                                        </div>
                                    </div>
                                    <div class="chat_main_r_main_list_mr_time">
                                        {{ item.createTime ? item.createTime.replace('T', ' ') : '' }}
                                    </div>
                                </div>
                                <!-- 左边 -->
                                <div class="chat_main_r_main_list_ml column" v-if="item.fromId != userId">
                                    <div class="chat_main_r_main_list_m_l row" v-if="item.type == 1">
                                        <img src="@/assets/images/resumeheader.jpg" class="chat_main_r_main_list_m_l_img">
                                        <div class="chat_main_r_main_list_m_l_text">
                                            {{ item.content }}
                                        </div>
                                    </div>
                                    <div class="chat_main_r_main_list_m_l row" v-if="item.type == 2">
                                        <img src="@/assets/images/resumeheader.jpg" class="chat_main_r_main_list_m_l_img">
                                        <div class="chat_main_r_main_list_m_l_text column">
                                            <div style="padding: 5px 0;">
                                                对方像你索要简历，是否同意？
                                            </div>
                                            <el-button size="small" @click="tongyifasongjianli(3)"
                                                :disabled="buttonfajianli">
                                                {{ buttonfajianli ? '已发简历' : '同意' }}
                                            </el-button>
                                        </div>
                                    </div>
                                    <div class="chat_main_r_main_list_m_l row" v-if="item.type == 4">
                                        <img src="@/assets/images/resumeheader.jpg" class="chat_main_r_main_list_m_l_img">
                                        <div class="chat_main_r_main_list_m_l_text column">
                                            <div v-if="buttonfadianhua">
                                                对方电话：{{ item.content }}
                                            </div>
                                            <div class="column" v-else>
                                                <div style="padding: 5px 0;">
                                                    对方向你互换电话
                                                </div>
                                                <el-button size="small" @click="huhuanshoujihao(5)"
                                                    :disabled="buttonfadianhua">
                                                    {{ buttonfadianhua ? '已同意' : '同意' }}
                                                </el-button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="chat_main_r_main_list_m_l row" v-if="item.type == 6">
                                        <img src="@/assets/images/resumeheader.jpg" class="chat_main_r_main_list_m_l_img">
                                        <div class="chat_main_r_main_list_m_l_text column">
                                            <div v-if="buttonfaweixin">
                                                对方微信：{{ item.content }}
                                            </div>
                                            <div class="column" v-else>
                                                <div style="padding: 5px 0;">
                                                    对方向你互换微信
                                                </div>
                                                <el-button size="small" @click="clickhuhuanweixin()">
                                                    {{ buttonfaweixin ? '已同意' : '同意' }}
                                                </el-button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="chat_main_r_main_list_mr_time2">
                                        {{ item.createTime ? item.createTime.replace('T', ' ') : '' }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="chat_main_r_bottom">
                        <div class="chat_main_r_bottom_m column">
                            <div class="chat_main_r_bottom_m_top row">
                                <el-button class="chat_main_r_bottom_m_top_m" @click="fasongxinxi(3)"
                                    :disabled="buttonfajianli">{{ buttonfajianli ? '已发简历' : '发简历' }}</el-button>
                                <el-button class="chat_main_r_bottom_m_top_m" @click="fasongxinxi(5)"
                                    :disabled="buttonfadianhua">{{ buttonfadianhua ? '已索要电话' : '互换电话' }}</el-button>
                                <el-popover placement="top" width="300" v-model="visiblehuhuanweixin">
                                    <div>
                                        <div>
                                            确定与对方交换微信吗？
                                        </div>
                                        <div style="margin: 10px 0;">
                                            你的微信号是：
                                        </div>
                                        <el-input v-model="huhuanweixin"></el-input>
                                    </div>

                                    <div style="text-align: right; margin: 10px 0 0">
                                        <el-button size="mini" type="text" @click="quxiaohuhuanweixin"
                                            style="padding: 7px 10px;">取消</el-button>
                                        <el-button type="primary" size="mini" @click="quedinghuhuanweixin">确定</el-button>
                                    </div>

                                    <el-button class="chat_main_r_bottom_m_top_m" slot="reference"
                                        style="margin-left: 10px;" :disabled="buttonfaweixin">
                                        {{ buttonfaweixin ? '已索要微信' : '互换微信' }}
                                    </el-button>
                                </el-popover>
                                <!-- <div class="chat_main_r_bottom_m_top_m" @click="fajianli">发简历</div>
                                <div class="chat_main_r_bottom_m_top_m" @click="huandianhua">换电话</div>
                                <div class="chat_main_r_bottom_m_top_m" @click="huanweixin">换微信</div> -->
                                <!-- <el-tooltip class="item" effect="dark" content="求简历：双方回复后可用" placement="top">
                                    <div class="chat_main_r_bottom_m_top_m">发简历</div>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="交换手机：双方回复后可用" placement="top">
                                    <div class="chat_main_r_bottom_m_top_m">换电话</div>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="交换微信：双方回复后可用" placement="top">
                                    <div class="chat_main_r_bottom_m_top_m">换微信</div>
                                </el-tooltip> -->
                            </div>
                            <el-input class="chat_main_r_bottom_m_textarea" type="textarea" resize="none" :rows="4"
                                v-model="xiaoxineirong" placeholder="请输入内容" @keydown.enter.native="handleEnter"></el-input>
                            <div class="chat_main_r_bottom_m_b row">
                                <div class="chat_main_r_bottom_m_b_text">按Enter键发送</div>
                                <div :class="xiaoxineirong ? 'chat_main_r_bottom_m_b_fasong2' : 'chat_main_r_bottom_m_b_fasong'"
                                    @click="clickFaSong">发送</div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <el-dialog title="选择简历" :visible.sync="dialogFormVisible">
            <el-select v-model="selectyingpingangwei" clearable placeholder="选择简历" @change="changeselectyingpingangwei"
                class="xuanzeyingpinggangwei">
                <el-option v-for="item in selectyingpingangweiList" :key="item.id" :label="item.fileName" :value="item.id">
                </el-option>
            </el-select>
            <div slot="footer" class="dialog-footer">
                <el-button @click="clickquxiao">取 消</el-button>
                <el-button type="primary" @click="clickxuanzegangwei">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="互换微信" :visible.sync="visiblehuhuanweixin2" width="30%" :before-close="quxiaohuhuanweixin2">
            <div>
                <div>
                    确定与对方交换微信吗？
                </div>
                <div style="margin: 10px 0;">
                    你的微信号是：
                </div>
                <el-input v-model="huhuanweixin2" placeholder="请输入您的微信"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="text" @click="quxiaohuhuanweixin2" style="padding: 7px 10px;">取消</el-button>
                <el-button type="primary" size="mini" @click="quedinghuhuanweixin2">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import NavTop from '@/components/NavTop.vue'

export default {
    name: 'LaChat',
    components: { NavTop },
    data() {
        return {
            userData: {},
            lianxiren: '',
            tabs: 1,
            xiaoxineirong: '',
            xunhuan: [
                {
                    type: 1,
                }, {
                    type: 2,
                }, {
                    type: 1,
                }, {
                    type: 2,
                }, {
                    type: 1,
                }, {
                    type: 2,
                }, {
                    type: 1,
                }, {
                    type: 2,
                }, {
                    type: 1,
                }, {
                    type: 2,
                }, {
                    type: 1,
                }, {
                    type: 2,
                },
            ],
            chatList: [],
            params: {
                page: 1,
                pageSize: 100,
				jobSeekerSource: 3,
            },
            chatParams: {
                page: 1,
                pageSize: 10,
                sessionId: '',
            },
            chatMessagesList: [],
            jieshouId: 0,
            huihuazhuangtai: false,
            isLoadingMore: false,
            hasMore: true,
            userId: 0,
            info: {},
            sessionId: 0,
            xuanzeId: 0,
            dingbugundong: false,
            buttonfajianli: false,
            buttonfadianhua: false,
            buttonfaweixin: false,
            dialogFormVisible: false,
            yingpingangweiid: '',
            selectyingpingangwei: '',
            selectyingpingangweiList: [],
            visiblehuhuanweixin: false,
            huhuanweixin: '',
            visiblehuhuanweixin2: false,
            huhuanweixin2: '',
        }
    },
    mounted() {
        console.log(111);
        this.$nextTick(() => {
            this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;
        });
        // 添加滚动事件监听
        console.log(window.addEventListener('chatbox', this.handleScroll));
    },
    activated() {
        // 获取用户信息
        this.getUserInfo();
        // 会话列表
        this.getChatSessionsList();
    },
    created() {
        this.$websocket.subscribe('*', (message) => {
            console.log('message1-->', message);
            this.getChatSessionsList();
            this.$refs.navtop.childNavtop();
            this.jieshouxiaoxi(message.data) // Assuming message.data contains the actual message content
        });
    },
    methods: {
        // 获取用户信息
        async getUserInfo() {
            try {
                let res = await this.$API.getUserInfoApi();
                console.log('获取用户信息-->', res);
                if (res.code == 0) {
                    this.userData = res.data;
                    this.userId = res.data.id;
                } else {
                    this.$router.push('/');
                }
            } catch (error) {
                this.$router.push('/');
            }
        },
        // 会话列表
        async getChatSessionsList() {
            let res = await this.$API.getChatSessionsListApi(this.params);
            console.log('会话列表-->', res);
            if (res.code == 0) {
                this.chatList = [];
                this.chatList = res.data.records;
            }
        },
        clickSearchIcon() {
            console.log('搜索-->', this.lianxiren);
        },
        handleSearchEnter() {
            console.log('按下回车-->', this.lianxiren);
        },
        clickChatTabs(val) {
            this.tabs = val;
        },
        handleEnter(event) {
            // 阻止回车键的默认行为，即不执行换行操作
            event.preventDefault();
            this.clickFaSong();
        },
        // 追加接收的消息
        jieshouxiaoxi(data) {
            // console.log('追加接收的消息-->', data.data);
            if (data.data) {
                if (this.sessionId == data.data.sessionId) {
                    const now = new Date();
                    // 追加消息对象
                    let jieshouxiaoxi = {
                        "id": '',
                        "sessionId": data.data.sessionId,
                        "fromId": '',
                        "toId": '',
                        "type": data.data.type,
                        "content": data.data.msg,
                        "isRead": 1,
                        "isDeleted": 0,
                        "createTime": now.toLocaleDateString().replace(/\//g, '-') + ' ' + now.toLocaleTimeString(),
                    }
                    // 追缴聊天内容
                    this.chatMessagesList.push(jieshouxiaoxi);
                    console.log(' this.chatMessagesList-->', this.chatMessagesList);

                    // 滚动到底部
                    this.$nextTick(() => {
                        this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;
                    });
                }
            }

        },
        // 发送消息
        clickFaSong() {
            // 消息对象
            let json = {
				"content": this.xiaoxineirong,
				"type": 1,
				"sessionId": this.sessionId,
            }
            this.$websocket.sendPayload('chat_message', json)

            const now = new Date();

            // 追加消息对象
            let liaotian = {
                "id": '',
                "sessionId": this.sessionId,
                "fromId": this.userId,
                "toId": this.jieshouId,
                "type": 1,
                "content": this.xiaoxineirong,
                "isRead": 1,
                "isDeleted": 0,
                "createTime": now.toLocaleDateString().replace(/\//g, '-') + ' ' + now.toLocaleTimeString(),
            }
            // 追缴聊天内容
            this.chatMessagesList.push(liaotian);
            console.log(' this.chatMessagesList-->', this.chatMessagesList);

            // 滚动到底部
            this.$nextTick(() => {
                this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;
            });

            // 清空聊天框
            this.xiaoxineirong = '';
        },
        clickZhiding(item) {
            // 调用置顶接口
            this.postChatSessionsFixTopId(item.id);
        },
        clickquxiaoZhiding(item) {
            // 调用取消置顶接口
            this.postChatSessionsUnFixTopId(item.id);
        },
        // 点击沟通
        dianjigoutong(item) {
            console.log('点击沟通-->', item);
            this.buttonfajianli = item.sendResume;
            this.buttonfadianhua = item.sendMobile;
            this.buttonfaweixin = item.sendWechat;
            this.xuanzeId = item.id;
            this.info = item;
            this.huihuazhuangtai = true;
            this.jieshouId = item.opId;
            this.chatParams.sessionId = item.id;
            this.chatParams.page = 1;
            this.sessionId = item.id;
            this.getChatMessages();
        },
        // 列表置顶
        clickliebiaozhiding(item) {
            // 调用置顶接口
            this.postChatSessionsFixTopId(item.id);
        },
        // 取消置顶
        clickliebiaoquxiaozhiding(item) {
            // 调用取消置顶接口
            this.postChatSessionsUnFixTopId(item.id);
        },
        // 列表删除
        async clickliebiaoshanchu(item) {
            try {
                let res = await this.$API.delChatIdApi(item.id);
                console.log('列表删除-->', res);
                if (res.code == 0) {
                    this.$message.success('删除成功！');
                    this.getChatSessionsList();
                    this.huihuazhuangtai = false;
                } else {
                    this.$message.error('删除失败！');
                }

            } catch (error) {
                this.$message.error('删除失败！');
            }
        },
        // 调用置顶接口
        async postChatSessionsFixTopId(id) {
            try {
                let res = await this.$API.postChatSessionsFixTopIdApi(id);
                console.log('调用置顶接口-->', res);
                if (res.code == 0) {
                    this.$message.success('置顶成功！');
                    this.getChatSessionsList();
                    this.info.fixTop = 1;
                } else {
                    this.$message.error('置顶失败！');
                }
            } catch (error) {
                this.$message.error('置顶失败！');

            }

        },
        // 调用取消置顶接口
        async postChatSessionsUnFixTopId(id) {
            try {
                let res = await this.$API.postChatSessionsUnFixTopIdApi(id);
                console.log('调用取消置顶接口-->', res);
                if (res.code == 0) {
                    this.$message.success('取消成功！');
                    this.getChatSessionsList();
                    this.info.fixTop = 0;
                } else {
                    this.$message.error('取消失败！');
                }
            } catch (error) {
                this.$message.error('取消失败！');

            }
        },
        handleScroll(event) {
            if (this.hasMore && !this.isLoadingMore && this.isScrollToTop(event)) {
                console.log('-->', event);
                this.chatParams.page = this.chatParams.page + 1;
                this.getChatMessages();
            }

            // 处理滚动事件
            // console.log(window.scrollY); // 输出当前滚动位置
            // if (window.scrollY > 90) {
            //     this.guding = true;
            // } else {
            //     this.guding = false;
            // }
        },
        // 检查是否滚动到顶部
        isScrollToTop(event) {
            const { scrollTop } = event.target;
            this.dingbugundong = true;
            return scrollTop === 0;
        },
        // 获取指定会话的消息
        async getChatMessages() {
            let res = await this.$API.getChatMessagesApi(this.chatParams);
            console.log('获取指定会话的消息-->', res);
            if (res.code == 0) {
                if (this.chatParams.page == 1) {
                    this.chatMessagesList = [];
                    this.chatMessagesList = res.data.records.reverse();
                    setTimeout(() => {
                        this.$nextTick(() => {
                            this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;
                        });
                    }, 100);
                    this.$refs.navtop.childNavtop();
                }
                if (this.chatParams.page > 1) {
                    this.chatMessagesList = res.data.records.reverse().concat(this.chatMessagesList)
                    // console.log('this.chatMessagesList-->', res.data.records.reverse().concat(this.chatMessagesList));
                }
            }

            if (this.dingbugundong) {
                this.$nextTick(() => {
                    this.$refs.chatbox.scrollTop = 10;
                });
                this.dingbugundong = false;
            }
            this.getChatSessionsList();
        },
        // 发送信息
        fasongxinxi(val) {
            if (val == 3) {
                // 发简历
                console.log('发简历-->', val);
                // this.clickFaSongsuoyaoxinxi(val, '你已向对方发送简历', '你已向对方发送简历');
                // this.buttonfajianli = true;
                this.tongyifasongjianli();
            }
            if (val == 5) {
                // 发电话
                console.log('发电话-->', val);
                this.clickFaSongsuoyaoxinxi(val, this.userData.phoneNumber, this.userData.phoneNumber);
                this.buttonfadianhua = true;
            }
            if (val == 7) {
                // 发微信
                console.log('发微信-->', val);
                // this.clickFaSongsuoyaoxinxi(val, '你已向对方发送微信', '你已向对方发送微信');
                // this.buttonfaweixin = true;
            }

        },
        // 同意发送简历
        tongyifasongjianli() {
            this.dialogFormVisible = true;
            this.selectyingpingangwei = '';
            this.getResumeFile();
        },
        // 发送消息
        clickFaSongsuoyaoxinxi(type, idcanshu, neirong) {
            // 使用新的websocket sendPayload方法发送消息，并统一格式
            const payloadData = {
                "content": idcanshu, // 统一使用 'content' 字段
                "type": type,
                "toId": this.jieshouId,
                "sessionId": this.sessionId,
                "toType": 2, // 1是猎头，2是hr
            };
            this.$websocket.sendPayload('chat_message', payloadData);

            const now = new Date();

            // 追加消息对象
            let liaotian = {
                "id": '',
                "sessionId": this.sessionId,
                "fromId": this.userId,
                "toId": this.jieshouId,
                "type": type,
                "content": neirong,
                "isRead": 1,
                "isDeleted": 0,
                "createTime": now.toLocaleDateString().replace(/\//g, '-') + ' ' + now.toLocaleTimeString(),
            }
            // 追缴聊天内容
            this.chatMessagesList.push(liaotian);
            console.log(' this.chatMessagesList-->', this.chatMessagesList);

            // 滚动到底部
            this.$nextTick(() => {
                this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;
            });

            // 清空聊天框
            this.xiaoxineirong = '';
        },
        // 简历列表
        async getResumeFile() {
            let res = await this.$API.getResumeFileApi({ page: 1, pageSize: 100 });
            console.log('简历列表-->', res);
            this.selectyingpingangweiList = res.data;
        },
        // 点击应聘岗位
        changeselectyingpingangwei(val) {
            console.log('点击应聘岗位-->', val);
            this.yingpingangweiid = val;
            // 获取列表
            this.getPositionList();
        },
        // 选择岗位取消
        clickquxiao() {
            this.dialogFormVisible = false;
            this.selectyingpingangwei = '';
        },
        // 选择岗位确定
        clickxuanzegangwei() {
            if (this.yingpingangweiid) {
                this.dialogFormVisible = false;
                this.selectyingpingangwei = '';
                this.clickFaSongsuoyaoxinxi(3, this.yingpingangweiid, '你已向对方发送简历')
            } else {
                this.$message({
                    message: '请选择应聘岗位！',
                    type: 'warning'
                });
            }
        },
        // 互换手机号
        huhuanshoujihao() {
            this.clickFaSongsuoyaoxinxi(5, this.userData.phoneNumber, this.userData.phoneNumber);
            this.getChatMessages();
        },
        // 互换微信
        clickhuhuanweixin() {
            this.visiblehuhuanweixin2 = true;
        },
        // 取消互换微信
        quxiaohuhuanweixin() {
            this.huhuanweixin = '';
            this.visiblehuhuanweixin = false;
        },
        // 确定互换微信
        quedinghuhuanweixin() {
            this.clickFaSongsuoyaoxinxi(7, this.huhuanweixin, this.huhuanweixin);
            this.visiblehuhuanweixin = false;
            this.huhuanweixin = '';
            this.buttonfaweixin = true;
        },
        // 取消互换微信2
        quxiaohuhuanweixin2() {
            this.huhuanweixin2 = '';
            this.visiblehuhuanweixin2 = false;
        },
        // 确定互换微信2
        quedinghuhuanweixin2() {
            this.clickFaSongsuoyaoxinxi(7, this.huhuanweixin2, this.huhuanweixin2);
            this.visiblehuhuanweixin2 = false;
            this.huhuanweixin2 = '';
            this.buttonfaweixin = true;
        },
        // 跳转
        tiaozhuanzhaopin() {
            this.$router.push('/jobdetail/' + this.info.jobId);
        }


    }

}
</script>

<style scoped>
.chat {
    max-width: 1200px;
    min-height: calc(100vh - 70px);
    margin: 10px auto 0;
}

.chat_main {
    border-radius: 10px;
    overflow: hidden;
    justify-content: space-between;
}

.chat_main_l {
    width: 360px;
    height: calc(100vh - 70px);
    background: #fff;
    border-radius: 10px;
}

.chat_main_l_top {
    display: flex;
    width: calc(100% - 40px);
    height: 48px;
    background: linear-gradient(90deg, #f5fcfc, #fcfbfa);
    border-radius: 12px 12px 0 0;
    padding: 0 20px;
    align-items: center;
}

.el-icon-search {
    cursor: pointer;
}

.chat_main_l_m {
    width: 340px;
    height: auto;
    padding: 0 10px;
}

.chat_main_l_m_tabs {
    padding: 10px 20px;
    justify-content: space-between;
}

.chat_main_l_m_tabs_m {
    cursor: pointer;
    display: inline-block;
    padding: 8px;
    background: #f8f8f8;
    border-radius: 4px;
    position: relative;
    font-size: 14px;
    color: #414a60;
}

.chat_main_l_m_tabs_m:hover {
    background: #00b2771a;
    color: #00b277;
}

.chat_main_l_m_tabs_m2 {
    cursor: pointer;
    display: inline-block;
    padding: 8px;
    background: #00b2771a;
    border-radius: 4px;
    position: relative;
    font-size: 14px;
    color: #00b277;
}

.chat_main_l_m_list {
    width: 100%;
    height: calc(100vh - 20vh);
    overflow-y: auto;
    padding: 0 10px 0 0;
}

.chat_main_l_m_list::-webkit-scrollbar {
    width: 5px;
}

.chat_main_l_m_list::-webkit-scrollbar-track {
    background: #fff;
}

.chat_main_l_m_list::-webkit-scrollbar-thumb {
    background: #dddddd;
    border-radius: 5px;
}

.chat_main_l_m_list::-webkit-scrollbar-thumb:hover {
    background: #fff;
}


.chat_main_l_m_list_m {
    padding: 14px 10px;
    cursor: pointer;
    position: relative;
}

.chat_main_l_m_list_m:hover {
    background: #f7f7f7;
}


.chat_main_l_m_list_m:hover .chat_main_l_m_list_m_r_bottom_del {
    display: block;
}

.chat_main_l_m_list_m2 {
    padding: 14px 10px;
    cursor: pointer;
    position: relative;
    background-color: #f2f2f2;
    border-radius: 4px;
}

.chat_main_l_m_list_m2:hover {
    background: #f7f7f7;
}

.chat_main_l_m_list_m2:hover .chat_main_l_m_list_m_r_bottom_del {
    display: block;
}

.chat_main_l_m_list_m_l {
    position: relative;
}

.chat_main_l_m_list_m_l_num {
    position: absolute;
    top: -5px;
    right: -5px;
    text-align: center;
    height: 15px;
    font-size: 12px;
    color: #fff;
    line-height: 15px;
    display: inline-block;
    background: #fe574a;
    border-radius: 9px;
    min-width: 15px;
    padding: 2px;
    z-index: 1;
}

.chat_main_l_m_list_m_l_img {
    width: 46px;
    height: 46px;
    border-radius: 50%;
}

.chat_main_l_m_list_m_r {
    flex: 1;
    margin-left: 15px;
    justify-content: space-around;
}

.chat_main_l_m_list_m_r_top {
    justify-content: space-between;
}

.chat_main_l_m_list_m_r_top_l {
    width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    align-items: flex-start;
}

.chat_main_l_m_list_m_r_top_l_name {
    font-size: 15px;
    font-weight: 500;
    color: #222;
}

.chat_main_l_m_list_m_r_top_l_gongsi {
    font-size: 13px;
    font-weight: 400;
    color: #333;
    margin-left: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.chat_main_l_m_list_m_r_top_r {
    width: 60px;
    font-size: 13px;
    color: #b3b3b3;
    text-align: right;
}

.chat_main_l_m_list_m_r_bottom {
    justify-content: space-between;
}

.chat_main_l_m_list_m_r_bottom_text {
    color: #999;
    width: 200px;
    height: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.chat_main_l_m_list_m_r_bottom_del {
    width: 35px;
    display: none;
}

.chat_main_l_m_list_m_r_bottom_del i {
    color: #00b277;
}

.chat_main_l_m_list_bottom {
    padding: 5px 5px 20px;
    font-size: 13px;
    text-align: center;
    color: #bfbfbf;
}



.chat_main_r {
    width: 835px;
    height: calc(100vh - 70px);
    background: #fff;
    border-radius: 10px;
}

.chat_main_r_top {
    width: 100%;
    height: auto;
}

.chat_main_r_top_t {
    height: 48px;
    justify-content: space-between;
    padding: 0 30px;
    align-items: center;
}

.chat_main_r_top_t_l {
    flex: 1;
    align-items: flex-end;
}

.chat_main_r_top_t_l_name {
    color: #666;
    line-height: 25px;
    margin-right: 10px;
    font-size: 16px;
    font-weight: bolder;
}

.chat_main_r_top_t_l_gongsi {
    font-size: 14px;
    font-weight: 400;
    color: #666;
    line-height: 22px;
}

.chat_main_r_top_t_r {}

.chat_main_r_top_t_r_zhiding {
    height: 26px;
    line-height: 26px;
    padding: 0 10px;
    background: #00b2771a;
    border-color: transparent;
    font-size: 14px;
    font-weight: 400;
    color: #00b277;
    cursor: pointer;
}

.chat_main_r_top_b {
    width: 780px;
    background: linear-gradient(90deg, #f5fcfc, #fcfbfa);
    padding: 16px;
    border-radius: 12px;
    margin: auto;
}

.chat_main_r_top_b_l {
    align-content: center;
    cursor: pointer;
}

.chat_main_r_top_b_l_job {
    font-weight: 500;
    color: #222;
    line-height: 22px;
    font-size: 16px;
    cursor: pointer;
}

.chat_main_r_top_b_l_job:hover {
    color: #00b277;
}

.chat_main_r_top_b_l_xinzi {
    font-size: 20px;
    color: #fe574a;
    line-height: 24px;
    vertical-align: bottom;
    margin-left: 16px;
}

.chat_main_r_top_b_l_dizhi {
    font-size: 16px;
    color: #333;
    line-height: 22px;
    margin-left: 16px;
}

.chat_main_r_main {
    width: 100%;
    height: 100%;
    background-color: #fff;
    overflow: auto;
}

.chat_main_r_main::-webkit-scrollbar {
    width: 5px;
}

.chat_main_r_main::-webkit-scrollbar-track {
    background: #fff;
}

.chat_main_r_main::-webkit-scrollbar-thumb {
    background: #dddddd;
    border-radius: 5px;
}

.chat_main_r_main::-webkit-scrollbar-thumb:hover {
    background: #fff;
}

.chat_main_r_main_list {
    width: calc(100% - 60px);
    height: auto;
    padding: 20px 30px 20px;
    overflow: hidden;
}

.chat_main_r_main_list_m {
    width: 100%;
    margin-bottom: 20px;
    /* overflow: auto; */
}

.chat_main_r_main_list_mr {
    float: right;
}

.chat_main_r_main_list_mr_time {
    color: #999;
    font-size: 12px;
    margin-top: 5px;
    text-align: right;
}

.chat_main_r_main_list_mr_time2 {
    color: #999;
    font-size: 12px;
    margin-top: 5px;
    margin-left: 50px;
}


.chat_main_r_main_list_m_r {
    justify-content: end;
}

.chat_main_r_main_list_m_r_text {
    color: #333;
    background-color: #00b27733;
    line-height: 22px;
    max-width: 420px;
    padding: 8px 12px;
    border-radius: 8px;
}

.chat_main_r_main_list_ml {}

.chat_main_r_main_list_m_l {}

.chat_main_r_main_list_m_l_img {
    width: 36px;
    height: 36px;
    border-radius: 100%;
    margin-right: 10px;
}

.chat_main_r_main_list_m_l_text {
    line-height: 22px;
    max-width: 420px;
    padding: 8px 12px;
    border-radius: 8px;
    background-color: #f8f8f8;
    color: #333;
}

.chat_main_r_bottom {
    width: 100%;
    height: auto;
    border-top: 1px solid #e6e8eb;
}

.chat_main_r_bottom_m_top {
    color: #999;
}

.chat_main_r_bottom_m_top_m {
    height: 24px;
    border-radius: 4px;
    border: 1px solid #e6e8eb;
    padding: 0 10px;
    line-height: 22px;
    vertical-align: top;
    margin-right: 10px;
    cursor: pointer;
}

.chat_main_r_bottom_m_top_m:hover {
    color: #00b277;
    border: 1px solid #00b277;
}

.chat_main_r_bottom_m_top_m2 {
    width: 100%;
    height: 24px;
    border-radius: 4px;
    border: 1px solid #e6e8eb;
    padding: 0 10px;
    line-height: 22px;
    vertical-align: top;
    margin-right: 10px;
    cursor: pointer;
}

.chat_main_r_bottom_m {
    height: 165px;
    padding: 15px 30px 10px;
    justify-content: space-between;
}

.chat_main_r_bottom_m_b {
    align-items: center;
    justify-content: right;
}

.chat_main_r_bottom_m_b_text {
    padding-right: 20px;
    color: #ccc;
    font-size: 14px;
}

.chat_main_r_bottom_m_b_fasong {
    cursor: default;
    color: #ededed;
    border-color: #ededed;
    background-color: #fff;
    font-size: 14px;
    line-height: 28px;
    min-width: auto;
    height: 28px;
    margin-right: 0;
    padding: 0 16px;
    border-radius: 6px;
    border: 1px solid #ededed;
}

.chat_main_r_bottom_m_b_fasong2 {
    cursor: pointer;
    color: #fff;
    background: #00b277;
    border-color: #00b277;
    font-size: 14px;
    line-height: 28px;
    min-width: auto;
    height: 28px;
    margin-right: 0;
    padding: 0 16px;
    border-radius: 6px;
    border: 1px solid #00b277;
}

.zhidingjiantou {
    position: absolute;
    top: 0;
    right: 0;
    width: 14px;
    height: 14px;
    content: "";
}

.chat_main_r_imgtext {
    position: relative;
    height: 100%;
    text-align: center;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.chat_main_r_img {
    width: 200px;
}

.chat_main_r_text {
    font-size: 20px;
    font-size: 13px;
    width: 100%;
    margin-top: 30px;
    color: #666;
}

.lianxirenliebiao {
    font-size: 16px;
    font-weight: 500;
    color: #222;
}

.xuanzeyingpinggangwei {
    width: 100%;
    margin-right: 20px;
}
</style>
